/* eslint-disable jsx-a11y/iframe-has-title */
import { Box, Typography } from '@mui/material';
import React from 'react';

const Map = () => {
  return (
    <Box
      sx={{
        mb: 4,
        maxWidth: '100%',
        position: 'relative',
      }}
    >
      <Typography variant="h6" sx={{ mb: 2 }}>
        Мы здесь
      </Typography>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d224.2328841528897!2d74.58775933048273!3d42.867435808044206!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x389ec9a36dc89989%3A0x46dea747e2828207!2sKorean%20Outlet!5e0!3m2!1sru!2skg!4v1729962471258!5m2!1sru!2skg"
        width="100%" // Changed to 100% for responsiveness
        height="450"
        style={{ border: 0, borderRadius: '10px' }} // Corrected style definition
        allowFullScreen // Changed to camelCase
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </Box>
  );
};

export default Map;
